import { render, staticRenderFns } from "./GenerateInvoices.vue?vue&type=template&id=ba046d3a"
import script from "./GenerateInvoices.vue?vue&type=script&lang=js"
export * from "./GenerateInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports